// extracted by mini-css-extract-plugin
module.exports =  {"modalWidth":"564px","modal":"modal--azHbh","head":"head--gcTwv","action-btn":"action-btn--CmWX1","actionBtn":"action-btn--CmWX1","body":"body--wz162"};